module.exports = __webpack_public_path__ + "img/ch65.7c0328d6.jpg";